import FileBrowserState from 'redux/fileBrowser/interfaces/fileBrowserState';

const INIT_FILE_BROWSER_STATE: FileBrowserState = {
  isOpened: false,
  content: null,
};

export default INIT_FILE_BROWSER_STATE;
